import { Richtwert } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Richtwert';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ArbeitszeitkontoStundenlohn() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <div className="flex flex-col gap-4">
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.label',
        )}
        item={
          !data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze
            ? t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.options.false',
              )
            : data.bezahlung.arbeitszeitkonto.stundenloehner
                  .auszahlungsgrenzeEuro
              ? `${data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro} ${t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEuro.suffix',
                )}`
              : `${data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeStunden} ${t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeStunden.suffix',
                )}`
        }
      />
      {!data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze && (
        <Richtwert />
      )}
    </div>
  );
}
